import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import ReportView from './ReportView';

const PatchReport = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Activity Log" dropdown={2} showBackButton={true} />

        <Card className="flex-1">
          <ReportView />
        </Card>
      </div>
    </div>
  );
};

export default PatchReport;
